<section role="region" aria-labelledby="h2Activities">
  <!-- Token: Activities -->
  <div class="sectionHeader" [ngClass]="{'hidden': !isMobile}">
    <h2 id="h2Activities">
      {{ 'k002951' | translate }}
    </h2>
  </div>
  <div>
<div class="tech-contents">
  <!-- Versión Desktop-->
  <div *ngIf="activityList.length > 0 && !isMobile">
    <div class="contentTimeline">
      <div id="vertical-timeline" class="light-timeline no-margins" #scrollMe>
        <div
          id="vertical-timeline-block"
          class="light-timeline no-margins"
          *ngFor="let item of activityList; let i = index"
        >
          <div
            class="system"
            *ngIf="
              i === 0 || activityList[i - 1].groupedDate !== item.groupedDate
            "
          >
            <div class="time-stamp">{{ item.groupedDate }}</div>
          </div>
          <div class="vertical-timeline-block">
            <!--En caso de que sea CANCELLED O EXPIRED-->
            <ng-container
              *ngIf="
                item.Status == 'CANCELED' ||
                item.Status == 'CANCELLED' ||
                item.Status == 'EXPIRED' ||
                item.Status == 'REJECTED'
              "
            >
              <span
                matTooltip="{{
                  item.StatusDescription ? item.StatusDescription : item.Status
                }}"
                #tooltip="matTooltip"
                (click)="tooltip.toggle()"
              >
                <div class="vertical-timeline-icon novisible">
                  <fa-icon [icon]="getIcon(item)"></fa-icon>
                </div>
              </span>
            </ng-container>
            <!--En caso de que no sea CANCELLED O EXPIRED-->
            <ng-container
              *ngIf="
                !(
                  item.Status == 'CANCELED' ||
                  item.Status == 'CANCELLED' ||
                  item.Status == 'EXPIRED' ||
                  item.Status == 'REJECTED'
                )
              "
            >
              <span
                matTooltip="{{
                  item.StatusDescription ? item.StatusDescription : item.Status
                }}"
                #tooltip="matTooltip"
                (click)="tooltip.toggle()"
              >
                <div [class]="getTypeClass(item.Type.TypeCode)">
                  <fa-icon [icon]="getIcon(item)"></fa-icon>
                </div>
              </span>
            </ng-container>
            <div class="vertical-timeline-content touchpointGrid">
              <div
                class="basic-activitiesClose"
                [ngClass]="{
                  cancelled:
                    !panelOpenState &&
                    (item.Status != 'COMPLETED' ||
                      item.Status != 'PARTIAL_COMPLETED' ||
                      item.Status != 'PARTIALLY_COMPLETED')
                }"
              >
                <mat-expansion-panel
                  [disabled]="isDisabled(item)"
                  (opened)="onExpandOpen(item)"
                  (closed)="panelOpenState = false"
                >
                  <mat-expansion-panel-header [@.disabled]="true">
                    <mat-panel-description>
                      <div class="gridMatExpansionPanel">
                        <div class="fecha">{{ item.CreatedDateString1 }}</div>
                        <!--En caso de que sea CANCELLED O EXPIRED-->
                        <ng-container
                          *ngIf="
                            item.Status == 'CANCELED' ||
                            item.Status == 'CANCELLED' ||
                            item.Status == 'EXPIRED' ||
                            item.Status == 'REJECTED'
                          "
                        >
                          <div class="simbolo">
                            <fa-icon
                              [icon]="
                                getActivitiesIcon(
                                  item.Type.TypeCode,
                                  'novisible2'
                                )
                              "
                              [class]="
                                getActivitiesClass(
                                  item.Type.TypeCode,
                                  'novisible2'
                                )
                              "
                            ></fa-icon>
                          </div>
                        </ng-container>
                        <!--En caso de que no sea CANCELLED O EXPIRED-->
                        <ng-container
                          *ngIf="
                            !(
                              item.Status == 'CANCELED' ||
                              item.Status == 'CANCELLED' ||
                              item.Status == 'EXPIRED' ||
                              item.Status == 'REJECTED'
                            )
                          "
                        >
                          <div class="simbolo">
                            <fa-icon
                              [icon]="getActivitiesIcon(item.Type.TypeCode, '')"
                              [class]="
                                getActivitiesClass(item.Type.TypeCode, '')
                              "
                            ></fa-icon>
                          </div>
                        </ng-container>
                        <div
                          *ngIf="
                            item.Status == 'COMPLETED' ||
                            item.Status == 'PARTIAL_COMPLETED' ||
                            item.Status == 'PARTIALLY_COMPLETED'
                          "
                          class="descripcion colorblue"
                        >
                          {{ item.Description }}

                          <fa-icon
                            *ngIf="isIcono(item)"
                            icon="info-circle"
                            class="coloricono"
                            #activitiesTooltip="matTooltip"
                            (click)="
                              activitiesTooltipShow(activitiesTooltip, item)
                            "
                            matTooltip=""
                            matTooltipPosition="above"
                            [matTooltipHideDelay]="1000"
                          ></fa-icon>
                        </div>
                        <div
                          *ngIf="
                            !(
                              item.Status == 'COMPLETED' ||
                              item.Status == 'PARTIAL_COMPLETED' ||
                              item.Status == 'PARTIALLY_COMPLETED'
                            )
                          "
                          class="descripcion"
                        >
                          {{ item.Description }}

                          <fa-icon
                            *ngIf="isIcono(item)"
                            icon="info-circle"
                            class="coloricono"
                            #activitiesTooltip="matTooltip"
                            (click)="
                              activitiesTooltipShow(activitiesTooltip, item)
                            "
                            matTooltip=""
                            matTooltipPosition="above"
                            [matTooltipHideDelay]="1000"
                          ></fa-icon>
                        </div>
                        <div
                          *ngIf="item.Status == 'COMPLETED'"
                          class="cantidad"
                        >
                          {{
                            item.InflowCashoutValue
                              | trCurrency
                                : (item.InflowCashoutCCY
                                    ? item.InflowCashoutCCY
                                    : item.Currency)
                          }}
                        </div>
                        <!-- InflowCashOutCCY {{item.AmountExecuted | trCurrency: item.Currency:'1.2-2' }} -->
                        <div
                          *ngIf="!(item.Status == 'COMPLETED')"
                          class="cantidad"
                        >
                          {{
                            item.InflowCashoutValue
                              | trCurrency
                                : (item.InflowCashoutCCY
                                    ? item.InflowCashoutCCY
                                    : item.Currency)
                          }}
                        </div>
                        <!--{{item.InflowCashoutValue | trCurrency: item.Currency:'1.2-2' }}-->
                        <!--cambios ultimos-->
                        <div
                          *ngIf="
                            !(
                              item.Status == 'COMPLETED' &&
                              item.Status == 'PARTIAL_COMPLETED' &&
                              item.Status == 'PARTIALLY_COMPLETED' &&
                              item.Status == 'CANCELLED' &&
                              item.Status == 'CANCELED' &&
                              item.Status == 'EXPIRED'
                            )
                          "
                          class="estado divBenchmark"
                        >
                          <span
                            *ngIf="
                              item.Status == 'PENDING' || item.Status == 'RETRY'
                            "
                            class="label spanBenchmark"
                            >{{ 'k000092' | translate }}</span
                          >
                          <!--Pending-->
                          <span
                            *ngIf="
                              item.Status == 'ORDERS_IN_ EXECUTION' ||
                              item.Status == 'IN_PROGRESS'
                            "
                            class="label spanBenchmark"
                            >{{ 'k001799' | translate }}</span
                          >
                          <!--En proceso-->
                        </div>
                        <div class="flechadetail">
                          <span
                            *ngIf="isDisabled(item)"
                            [class]="getIndicatorClass(item)"
                            (click)="popupSee(item)"
                          ></span>
                        </div>
                      </div>
                    </mat-panel-description>
                    <!--<span *ngIf="isDisabled(item)" [class]="getIndicatorClass(item)" (click)="popupSee(item)" class="flechadetail"></span>-->
                    <!--<span *ngIf="!isDisabled(item)" [class]="'one'"></span>-->
                  </mat-expansion-panel-header>
                  <div class="subitemdescription">
                    <div class="textooperacion" *ngIf="isVisiblemessage">
                      <span class="colorblue">
                        {{ item.messageValues }}
                      </span>
                    </div>
                    <dx-data-grid
                      id="gridContainerOrders"
                      class="tech-table-info"
                      [columns]="colsTrades"
                      [dataSource]="item.Orders"
                      [showBorders]="false"
                      [showColumnLines]="false"
                      [showRowLines]="true"
                      [columnAutoWidth]="true"
                      [wordWrapEnabled]="false"
                      [paging]="false"
                      [showColumnHeaders]="false"
                      (onRowPrepared)="onRowPrepared($event)"
                      (onRowExpanded)="onRowExpanded($event)"
                      [hoverStateEnabled]="true"
                      (onRowClick)="onRowClick($event)"
                      (onRowCollapsed)="onRowCollapsed($event)"
                      (onCellPrepared)="onCellPrepared($event)"
                    >
                      <dxo-selection mode="single"></dxo-selection>
                      <!-- Desactiva cualquier tipo de ordenación-->
                      <dxo-sorting mode="none"></dxo-sorting>
                      <!--No permite que se collapse el grupo -->
                      <dxo-grouping
                        #expand
                        [allowCollapsing]="false"
                        [autoExpandAll]="true"
                      ></dxo-grouping>
                      <!--Para visualizar detalle dentro de la tabla -->
                      <dxo-master-detail
                        [enabled]="true"
                        template="detail"
                      ></dxo-master-detail>
                      <!-- Plantillas para celdas con html en el masterdetail-->
                      <div
                        *dxTemplate="let el of 'detail'"
                        class="detailswrapper opendetails_animation"
                      >
                        <div class="tablasecundaria">
                          <div class="nombre1">{{ 'k000999' | translate }}</div>
                          <div class="nombre2">{{ 'k002802' | translate }}</div>
                          <div class="nombre3">{{ 'k000306' | translate }}</div>
                          <div class="nombre4">{{ 'k000296' | translate }}</div>
                          <div class="nombre5">{{ 'k000048' | translate }}</div>
                          <div class="nombre6">{{ 'k000159' | translate }}</div>
                          <div class="valor1">{{ el.data.OperationType }}</div>
                          <div class="valor2">
                            {{ el.data.OrderDate | date : dateFormat }}
                          </div>
                          <div class="valor3">
                            {{
                              el.data.AmountExecuted
                                | trCurrency : el.data.Currency
                            }}
                          </div>
                          <div class="valor4">
                            {{ el.data.TitlesExecuted | trDouble }}
                          </div>
                          <div class="valor5">
                            {{
                              el.data.NetPriceExecuted
                                | trCurrency : el.data.Currency
                            }}
                          </div>
                          <div class="valor6">{{ el.data.Isin }}</div>
                        </div>
                      </div>
                      <!-- Plantillas para celdas con html-->
                      <div *dxTemplate="let row of 'groupCellTemplate'">
                        <div class="fontweight400">{{ row.value }}</div>
                      </div>
                      <div *dxTemplate="let row of 'templateName'">
                        <div class="tablaprincipal">
                          <div class="name div-ellipsis myTooltip">
                            {{ row.data.ProductName }}
                          </div>
                          <div class="tipo">&nbsp;</div>
                          <div class="nro1">
                            {{
                              row.data.AmountExecuted
                                | trCurrency : row.data.Currency
                            }}
                          </div>
                          <div class="nro2">{{ row.data.OperationType }}</div>
                        </div>
                      </div>
                    </dx-data-grid>
                  </div>
                </mat-expansion-panel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Versión Móvil -->
  <div *ngIf="activityList.length > 0 && isMobile">
    <div *ngFor="let item of activityList; let i = index">
      <div
        *ngIf="i === 0 || activityList[i - 1].groupedDate !== item.groupedDate"
      >
        <div class="time-stamp">{{ item.groupedDate }}</div>
      </div>
      <div class="basic-activitiesClose">
        <mat-expansion-panel
          [disabled]="isDisabled(item)"
          (opened)="onExpandOpen(item)"
          (closed)="panelOpenState = false"
        >
          <mat-expansion-panel-header [@.disabled]="true">
            <mat-panel-description>
              <div class="cardsContainer">
                <div class="imgContainer">
                  <div
                    class="redondeo"
                    [style.background-color]="
                      getChannelClassMovil(item.Type.TypeCode)
                    "
                  >
                    <ng-container
                      *ngIf="
                        item.Status == 'CANCELED' ||
                        item.Status == 'CANCELLED' ||
                        item.Status == 'EXPIRED' ||
                        item.Status == 'REJECTED'
                      "
                    >
                      <fa-icon
                        [icon]="
                          getActivitiesIcon(item.Type.TypeCode, 'novisible2')
                        "
                        [class]="
                          getActivitiesClass(item.Type.TypeCode, 'novisible2')
                        "
                      ></fa-icon>
                    </ng-container>
                    <ng-container
                      *ngIf="
                        !(
                          item.Status == 'CANCELED' ||
                          item.Status == 'CANCELLED' ||
                          item.Status == 'EXPIRED' ||
                          item.Status == 'REJECTED'
                        )
                      "
                    >
                      <fa-icon
                        [icon]="getActivitiesIcon(item.Type.TypeCode, '')"
                        [class]="getActivitiesClass(item.Type.TypeCode, '')"
                      ></fa-icon>
                    </ng-container>
                  </div>
                </div>
                <div
                  *ngIf="
                    item.Status == 'COMPLETED' ||
                    item.Status == 'PARTIAL_COMPLETED' ||
                    item.Status == 'PARTIALLY_COMPLETED'
                  "
                  class="contenido colorblue"
                >
                  <span class="touchpointTitle">{{ item.Description }} </span>

                  <fa-icon
                    *ngIf="isIcono(item)"
                    icon="info-circle"
                    class="coloricono pdiz"
                    #activitiesTooltip="matTooltip"
                    (click)="activitiesTooltipShow(activitiesTooltip, item)"
                    matTooltip=""
                    matTooltipPosition="above"
                    [matTooltipHideDelay]="1000"
                  ></fa-icon>

                  <fa-icon
                    *ngIf="isIcono(item)"
                    icon="info-circle"
                    class="coloricono pdiz"
                    #activitiesTooltip="matTooltip"
                    (click)="activitiesTooltipShow(activitiesTooltip, item)"
                    matTooltip=""
                    matTooltipPosition="above"
                    [matTooltipHideDelay]="1000"
                  ></fa-icon>
                </div>
                <div
                  *ngIf="
                    !(
                      item.Status == 'COMPLETED' ||
                      item.Status == 'PARTIAL_COMPLETED' ||
                      item.Status == 'PARTIALLY_COMPLETED'
                    )
                  "
                  class="contenido"
                >
                  <span class="touchpointTitle">{{ item.Description }} </span>

                  <fa-icon
                    *ngIf="isIcono(item)"
                    icon="info-circle"
                    class="coloricono pdiz"
                    #activitiesTooltip="matTooltip"
                    (click)="activitiesTooltipShow(activitiesTooltip, item)"
                    matTooltip=""
                    matTooltipPosition="above"
                    [matTooltipHideDelay]="1000"
                  ></fa-icon>
                </div>
                <div *ngIf="item.Status == 'COMPLETED'" class="cantidadestado">
                  <div class="cant">
                    {{ item.AmountExecuted | trCurrency : item.Currency }}
                  </div>
                  <div
                    class="est divBenchmark"
                    *ngIf="
                      !(
                        item.Status == 'COMPLETED' &&
                        item.Status == 'PARTIAL_COMPLETED' &&
                        item.Status == 'PARTIALLY_COMPLETED' &&
                        item.Status == 'CANCELLED' &&
                        item.Status == 'CANCELED' &&
                        item.Status == 'EXPIRED'
                      )
                    "
                  >
                    <span
                      *ngIf="item.Status == 'PENDING' || item.Status == 'RETRY'"
                      class="label spanBenchmark"
                      >{{ 'k000092' | translate }}</span
                    >
                    <!--Pending-->
                    <span
                      *ngIf="
                        item.Status == 'ORDERS_IN_ EXECUTION' ||
                        item.Status == 'IN_PROGRESS'
                      "
                      class="label spanBenchmark"
                      >{{ 'k001799' | translate }}</span
                    >
                    <!--En proceso-->
                  </div>
                </div>
                <div
                  *ngIf="!(item.Status == 'COMPLETED')"
                  class="cantidadestado"
                >
                  <div class="cant">
                    {{ item.InflowCashoutValue | trCurrency : item.Currency }}
                  </div>
                  <div
                    class="est divBenchmark"
                    *ngIf="
                      !(
                        item.Status == 'COMPLETED' &&
                        item.Status == 'PARTIAL_COMPLETED' &&
                        item.Status == 'CANCELLED' &&
                        item.Status == 'CANCELED' &&
                        item.Status == 'EXPIRED'
                      )
                    "
                  >
                    <span
                      *ngIf="item.Status == 'PENDING' || item.Status == 'RETRY'"
                      class="label spanBenchmark"
                      >{{ 'k000092' | translate }}</span
                    >
                    <!--Pending-->
                    <span
                      *ngIf="
                        item.Status == 'ORDERS_IN_ EXECUTION' ||
                        item.Status == 'IN_PROGRESS'
                      "
                      class="label spanBenchmark"
                      >{{ 'k001799' | translate }}</span
                    >
                    <!--En proceso-->
                  </div>
                </div>
                <div class="flechadetail2">
                  <span
                    *ngIf="isDisabled(item)"
                    [class]="getIndicatorClass(item)"
                    (click)="popupSee(item)"
                  ></span>
                </div>
              </div>
            </mat-panel-description>
            <!--<span *ngIf="isDisabled(item)" [class]="getIndicatorClass(item)" (click)="popupSee(item)"></span>-->
            <span *ngIf="!isDisabled(item)" [class]="'one'"></span>
          </mat-expansion-panel-header>
          <div class="subitemdescription">
            <div class="textooperacion" *ngIf="isVisiblemessage">
              <span class="colorblue">
                {{ item.messageValues }}
              </span>
            </div>
            <dx-data-grid
              id="gridContainerOrders"
              [columns]="colsTrades"
              [dataSource]="item.Orders"
              [showBorders]="false"
              [showColumnLines]="false"
              [showRowLines]="true"
              [columnAutoWidth]="false"
              [wordWrapEnabled]="true"
              [paging]="false"
              [showColumnHeaders]="false"
              (onRowPrepared)="onRowPrepared($event)"
            >
              <!-- Desactiva cualquier tipo de ordenación-->
              <dxo-sorting mode="none"></dxo-sorting>
              <!--No permite que se collapse el grupo -->
              <dxo-grouping
                #expand
                [allowCollapsing]="false"
                [autoExpandAll]="true"
              ></dxo-grouping>
              <!-- Plantillas para celdas con html-->
              <div *dxTemplate="let row of 'groupCellTemplate'">
                <div class="fontweight400">{{ row.value }}</div>
              </div>
              <div *dxTemplate="let row of 'templateMobile'">
                <div
                  class="tablaprincipal"
                  (click)="openDetail(row.data, item.Description)"
                >
                  <div class="name div-ellipsis myTooltip">
                    {{ row.data.ProductName }}
                  </div>
                  <div class="tipo">&nbsp;</div>
                  <div class="nro1">
                    {{
                      row.data.AmountExecuted | trCurrency : row.data.Currency
                    }}
                  </div>
                  <div class="nro2">{{ row.data.OperationType }}</div>
                </div>
              </div>
            </dx-data-grid>
          </div>
        </mat-expansion-panel>
      </div>
    </div>
  </div>

  <!--No Data-->
  <div *ngIf="activityList.length == 0" class="gridnodata">
    <div class="textonodata">{{ 'k002559' | translate }}</div>
  </div>
</div>
</div>
</section>